import React, { useEffect, useState } from "react";
import "./live-transaction.css";
import LinearGoldText from "./linear-gold-text.tsx";
import { Typography } from "@mui/material";

interface TransactionType {
  mobile: string;
  dateTime: string;
  amount: number;
  brand: string;
  id?: string;
}

const brandLogo = [
  require("../images/pg9/pg9-logo.png"),
  require("../images/h4win/h4win-logo.png"),
  require("../images/rr4win/rr4win-logo.png"),
  require("../images/boomerang/boomerang-logo.png"),
];

export default function LiveTransaction({ isMobile }) {
  const [dataList, setDataList] = useState<TransactionType[]>([]);

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);

  const pad = (num) => {
    return num < 10 ? "0" + num : num;
  };

  // const getDateString = (previousDay) => {
  //   const date = new Date();
  //   date.setDate(date.getDate() - previousDay);

  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const hours = String(date.getHours()).padStart(2, "0");
  //   const minutes = String(date.getMinutes()).padStart(2, "0");
  //   const seconds = String(date.getSeconds()).padStart(2, "0");

  //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  // };

  // const getCurrentLocaleAsUTC = () => {
  //   const date = new Date();

  //   const year = date.getUTCFullYear();
  //   const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  //   const day = String(date.getUTCDate()).padStart(2, "0");
  //   const hours = String(date.getUTCHours()).padStart(2, "0");
  //   const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  //   const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  //   // Return the formatted UTC time string with +00:00 offset
  //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  // };

  // const retryFetchData = async ({ accessId, accessToken, url }) => {
  //   return new Promise(async (resolve) => {
  //     const formData = new FormData();
  //     formData.append("module", "/transactions/getAllTransactions");
  //     formData.append("accessId", accessId);
  //     formData.append("accessToken", accessToken);
  //     formData.append("type", "WITHDRAW");
  //     formData.append("sDate", getDateString(1));
  //     try {
  //       const response = await fetch(`${url}api/v1/index.php`, {
  //         method: "POST",
  //         body: formData,
  //       });
  //       if (response.ok) {
  //         const responseData = await response.json();
  //         if (responseData.status === "SUCCESS") {
  //           resolve(responseData.data.transactions);
  //         } else {
  //           resolve([]);
  //         }
  //       } else {
  //         resolve([]);
  //       }
  //     } catch (error) {
  //       resolve([]);
  //     }
  //   });
  // };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://gold-partner-group-4893.onrender.com/api/v1/transactions`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const responseData = await response.json();

        if (responseData.status.toUpperCase() === "SUCCESS") {
          setDataList(responseData.transactions);
        } else {
          setDataList([]);
        }
      }
    } catch (error) {}
  };

  const getImage = (brand: any) => {
    if (brand === "RR4") {
      return brandLogo[2];
    } else if (brand === "H4") {
      return brandLogo[1];
    } else if (brand === "PG9") {
      return brandLogo[0];
    } else {
      return brandLogo[3];
    }
  };

  const getDateTime = (dateTime: string) => {
    const date = new Date(dateTime);
    const formattedDate = `${date.getFullYear()}-${pad(
      date.getMonth() + 1
    )}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
      date.getMinutes()
    )}`;

    return formattedDate;
  };

  if (dataList.length <= 0) return null;

  return (
    <div className="live-transaction-container">
      <div
        style={{
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.7)",
          padding: "25px 20px 25px 20px",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "30px",
          }}
        >
          <LinearGoldText isMobile={isMobile}>
            Partner Withdrawals
          </LinearGoldText>
          <div className="fade-container">
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "10px",
                backgroundColor: "white",
                marginRight: "5px",
              }}
            />
            <Typography
              style={{
                fontSize: isMobile ? "10px" : "14px",
              }}
            >
              Live
            </Typography>
          </div>
        </div>

        <div>
          {dataList.map((item: TransactionType) => (
            <div
              key={item.id || item.dateTime}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: isMobile ? "10px" : "20px",
              }}
            >
              <img
                src={getImage(item.brand)}
                style={{ width: isMobile ? "55px" : "75px" }}
                alt="BrandLogo"
              />
              <Typography style={{ fontSize: isMobile ? "12px" : "14px" }}>
                {item.mobile}
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    textAlign: "end",
                    fontSize: isMobile ? "14px" : "16px",
                    fontWeight: "600",
                    color: "rgba(8, 255, 0, 1)",
                  }}
                >
                  +{item.amount.toFixed(2)}
                </Typography>
                <Typography style={{ fontSize: isMobile ? "10px" : "12px" }}>
                  {getDateTime(item.dateTime)}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
